import React from "react";
import { Trans, useTranslation } from "react-i18next";
import SimpleLayout from "../../../layouts/Simple";
import { useHistory } from "react-router-dom";
import LogoCustomTheme from "components/Theme/Logo/LogoCustomTheme";

const Subscribed = () => {
  const { t } = useTranslation();
  const router = useHistory();

  const redirect = () => {
    // Links are better but I don't want to make style again
    router.push("/");
  };

  return (
    <SimpleLayout>
      <div className="default-container col-flex">
        <div className="mv20">
          <LogoCustomTheme className="we-are-ll" />
        </div>

        <div className="account-logo check"></div>

        {/* <p className="text-center">{t("newsletter_subscribed")}</p> */}
        <p
            dangerouslySetInnerHTML={{
              __html: t("newsletter_subscribed", {
                interpolation: { escapeValue: false },
              }),
            }}
        >
        </p>

        <div className="account-final-link">
          <button onClick={redirect}>{t("back_to_home")}</button>
        </div>
      </div>
    </SimpleLayout>
  );
};

export default Subscribed;
